module.exports = __webpack_public_path__ + "static/13-4bdc1f4f9ae9fc19ec3f8031de968dc7.png";